import React from "react";
import app from "@src/assets/images/img/app.png";
import google from "@src/assets/images/img/google.png";
import logo from "@src/assets/images/logo/logo.png";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import {
  EmailShareButton,
  FacebookMessengerShareButton,
  FacebookShareButton,
  TwitterShareButton,
  WhatsappShareButton,
} from "react-share";
import { FaFacebookMessenger } from "react-icons/fa";

const Footer = () => {
  const { t } = useTranslation();
  return (
    <div className="Ushnos ">
      <footer className="footer-part footer-gape">
        <div className="container__">
          <div className="row">
            <div className="col-lg-4">
              <div className="footer-logo">
                <Link to="/">
                  <img src={logo} alt="logo" />
                </Link>
              </div>
            </div>
            <div className="col-lg-2 col-sm-4 col-6">
              <h3 className="mb-1">{t("News")}</h3>
              <ul className="">
                <li>
                  <Link to="/dataNews/News/topics">{t("News")}</Link>
                </li>
                <li>
                  <Link to="/dataNews/Blog/topics">{t("Blog")}</Link>
                </li>
                <li>
                  <Link to="/dataNews/Services/topics">{t("Services")}</Link>
                </li>
              </ul>
            </div>
            <div className="col-lg-2 col-sm-4 col-6">
              <h3 className="mb-1">{t("Podcast")}</h3>
              <ul className="">
                <li>
                  <Link to="/schedule">{t("Calendar")}</Link>
                </li>
                <li>
                  <Link to="/emissions">{t("Emission")}</Link>
                </li>
                <li>
                  <Link to="/podcast">{t("Podcasts")}</Link>
                </li>
                <li>
                  <Link to="/playlists">{t("Playlists")}</Link>
                </li>
              </ul>
            </div>
            <div className="col-lg-2 col-sm-4 col-6">
              <h3 className="mb-1">{t("Gallery")}</h3>
              <ul className="">
                <li>
                  <Link to="/Gallery/Photos/topics">{t("Photos")}</Link>
                </li>
                <li>
                  <Link to="/Gallery/Videos/topics">{t("Videos")}</Link>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default Footer;
